<script setup lang="ts">
import { RouterLink } from 'vue-router'
</script>

<template>
  <RouterLink
    to="/" flex="~"
    items-center gap-2 px-2 outline-none
  >
    <img src="/logo.png" alt="XRearth" class="logo-img">
    <span class="text-text-primary font-mono text-lg tracking-tight">
      <span class="text-accent-blue">XR</span><span>earth</span>
    </span>
  </RouterLink>
</template>

<style scoped>
.logo-img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}
</style>
